
import SimilarBox from '@/components/SimilarBox';
export default {
  components: {
    SimilarBox
  },
  data() {
    return {
      goodsId: '',
      goodsNo: ''
    }
  },
  async asyncData({ route }) {
    
    const queryGoodsId = route.query.gameId;
    const queryGoodsNo = route.query.goodsNo;

    return {
      goodsId: queryGoodsId ? parseInt(queryGoodsId) : '',
      goodsNo: queryGoodsNo
    };
  },
  methods: {

  }
}
